import PropTypes from 'prop-types';

export default PropTypes.shape({
	ID: PropTypes.number,
	GlobalID: PropTypes.string,
	Name: PropTypes.string,
	Deletable: PropTypes.bool,
	DeleteDate: PropTypes.string
});